import gsap from 'gsap';

const bladeAnimations = {
	blade2: {
		doomSlayer: () => {
			gsap.fromTo(".doom-slayer", {opacity: .1}, {opacity: 1, duration: 3});
		},
	},

	blade5: {

		icon1: () => {
			const tl = gsap.timeline({repeat: -1, repeatDelay: .5});
			tl.from(".wifi-1", {opacity:0});
			tl.from(".wifi-2", {opacity:0});
			tl.from(".wifi-3", {opacity:0});
		},

		icon2: () => {
			const zoneContainer = document.querySelectorAll('.img-container')
			zoneContainer[2].style.width = "0";
			zoneContainer[2].style.overflow = "hidden";
			
			const tl = gsap.timeline({repeat:-1, repeatDelay: 1.5});
			tl.to(zoneContainer[2], .1, {width:20, delay: 0.5})
			tl.to(zoneContainer[2], .1, {width:40, delay: 0.5})
			tl.to(zoneContainer[2], .1, {width:60, delay: 0.5})

			const ts = gsap.timeline({repeat:-1});
			ts.to(zoneContainer[3], 2.5, { ease: "RoughEase.ease.config({ template:  Power0.easeOut, strength: 0.2, points: 10, taper: 'none', randomize:  false, clamp: true})", x: 10 });
			ts.yoyo(true);
		},

		icon3: () => {
			const tl = gsap.timeline(
				{defaults:
					{ease:"power2.out", 
					duration: .1, 
					repeat: -1,
					fill: "#FFFFFF",
					scale: .9,
					yoyo:true,
					}
				}
			);

			tl.to(".bandwidth", {y: '-1%', scale: 1.3, repeatDelay: .5,});
			tl.to(".bandwidth-2", {y: '-1%', scale: 1.3,repeatDelay: .5});
			tl.to(".bandwidth-3", {y: '-1%', scale: 1.3,repeatDelay: .5});
			tl.to(".bandwidth-4", {y: '-1%', scale: 1.3,repeatDelay: .5});
			tl.to(".bandwidth-5", {y: '-1%', scale: 1.3,repeatDelay: .5});
			tl.to(".bandwidth-6", {y: '-1%', scale: 1.3,repeatDelay: .5});
			tl.to(".bandwidth-7", {y: '-1%', scale: 1.3,repeatDelay: .5});	
		},

		icon4: () => {
			const tl = new gsap.timeline({repeat: -1});
			tl.from('#Cloud-Icon', {
				scale: 0.8, 
				ease: "power1.inOut", 
				duration: 3.5,
				transformOrigin: "bottom left"}
			)
			.yoyo(true);
		}
	},

	parallax: (domEl) => {
		var ele2Parallax = document.querySelector(domEl);
	
		function setTranslate(xPos, yPos, el) {
			el.style.transform = "translate3d(" + xPos + ", " + yPos + "px, 0)";
		}
	
		window.addEventListener("DOMContentLoaded", scrollLoop);
	
		var yScrollPosition;
	
		function scrollLoop() {
			yScrollPosition = window.scrollY;
	
			setTranslate(0, yScrollPosition * -.1, ele2Parallax);
	
			requestAnimationFrame(scrollLoop);
		}
	}
}


export default bladeAnimations
